import { useQuery } from '@grandvisionhq/graphql';
import { toRecentOrders } from '../mappers/profile.js';
import GET_RECENT_ORDERS from '../operations/queries/get-recent-orders.js';

const useRecentOrders = ()=>{
    var ref, ref1;
    const { data , loading , error  } = useQuery(GET_RECENT_ORDERS);
    /**
   * The business rule is to only show the last two orders.
   *
   * Even though we're only asking for the last two orders in the GET_RECENT_ORDERS query, we will
   * receive more than two orders from that query if Apollo already has orders in its cache.
   *
   * This will make sure we never show more than two orders (in case we have more orders cached).
   */ const orders = data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : (ref1 = ref.orders) === null || ref1 === void 0 ? void 0 : ref1.results.slice(0, 2);
    return {
        data: orders && toRecentOrders(orders),
        hasRecentOrders: !!(orders === null || orders === void 0 ? void 0 : orders.length),
        loading,
        error
    };
};

export { useRecentOrders };
//# sourceMappingURL=use-recent-orders.js.map
